function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import React from 'react';
var GalleryContext;

try {
  GalleryContext = React.createContext({});
} catch (e) {
  GalleryContext = null;
}

var GALLERY_CONTEXT_FIELDS = ['isUnknownWidth'];

var extractContextFields = function extractContextFields(fields) {
  return GALLERY_CONTEXT_FIELDS.reduce(function (obj, field) {
    obj[field] = fields[field];
    return obj;
  }, {});
};

var GalleryProvider = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(GalleryProvider, _React$Component);

  var _super = _createSuper(GalleryProvider);

  function GalleryProvider(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = extractContextFields(props);
    return _this;
  }

  var _proto = GalleryProvider.prototype;

  _proto.render = function render() {
    if (GalleryContext) {
      // const value = { ...this.value, ...this.state };
      return /*#__PURE__*/React.createElement(GalleryContext.Provider, {
        value: this.state
      }, this.props.children);
    } else {
      return this.props.children;
    }
  };

  return GalleryProvider;
}(React.Component);

export { GalleryContext, GalleryProvider, extractContextFields };